export default __webpack_public_path__ + "9f242a7fdf45a408d99341cf4571ad19.svg";